import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export function useFailedExtractionCount() {
  const query = useQuery({
    queryKey: ["failed-extraction-count"],
    queryFn: async (): Promise<number> => {
      const fiveMinutesAgo = new Date(Date.now() - 5 * 60 * 1000).toISOString();
      const { count, error } = await supabase
        .from("memories")
        .select("*", { count: "exact", head: true })
        .eq("extraction_version", 0)
        .lt("created_at", fiveMinutesAgo);
      if (error) throw error;
      return count ?? 0;
    },
    staleTime: 2 * 60 * 1000,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
